let echoSocketId: unknown;

export function getEchoSocketId() {
  return echoSocketId;
}

export function setEchoSocketId(socketId: unknown) {
  echoSocketId = socketId;
}
